const wetWilly = `
                                                  ....
                                                  ..:....
                                                  .-@@-...
                                                 ..+@@@-:..
                                               ...:%@+%@::..
                                               ...*@#=+@%::.
                                              ...*@#===*@*::..
                                             ...#@#=====+@#:...
                                            ..:%@*=======+@#...
                                          ...+@%=---------=%%::...
                                        ...:%@*-------------#@=....
                                        ..*@%----------------+@#....
                                     ...*@%=-------------------#@=....
                                  ....+@%=--------:::::::-------=@%:...
                                ....:%@+------::::::::::::::------#@*:....
                                ...*@*-------:::::::::::::::::-----=@@:...
                                ..#@+------::::::::::::::::::::-----=%@-:..
                  ......  .. ....%@=-------::::::-:....-*=::::::------#@+:..
                  ..............#@=-------:::::+@@%:..:%@@#:::::-------%@=:...
                  ..#@@@*..*@##@@+--------::::-%@@@-..:@@@@-::::-------=%@-:..
                ...%+...#*+%....@*=-------::::-@@@@-..:%@@%-::::--------=@%-:..
                ..:%=.  :%%=  .-@+=--------::::#@@*:::::#@*:::::--------=#@--:.
                 ..##.  .*@-  .#%==---------::::::::::::::::::---------===@#:-..
                ..:#@+...:%:=*+%*===----------::::::::::::::----------====@@:-..
               ..*@*:.**:.+=...*%===*@@@@%=-------:::::::------+@@@@@*====%@:=:.
              ..:@+.....%=.. .+.##+@%@%=--+----------------------=@#=##===#@:=:.
              ..-@:.#...+-...#=.=%++=*@=-------------------------*@+======@*-=..
               .:%+.:**+#%++-. .*#====@*===---------------------=%%======*@==-..
              ...=@-.....+: ...*@+====+@+======------------=====#@======+@@%:-..
               ...:%@+:....-*@@@%+++===+@*=====================%%+====++%#-%*-:.
                ...--@+:---:..:@@+++++==+%@+=================%@*====+++#%-:#%--..
                 ...:#@*---=*%@+*@#++++++++#@%#+=======++#%@%+===+++++#@*-+#@=::..
                 ..:+*.:--%@=::::-@@#++++++++++*%%%%%%%%#+==+++++++++#@%+:..=#@::..
                  .-****...:%@@@@@-.%@%+++++++++++++++++++++++++++++@@+..-+**=@-=:.
                 ...:-+**+==+:::.-=-==+@@#+++++++++++++++++++++++*@@=#@*:.....=@+:..
                  ...----+::-*++*+=++==--+%@#*+++++++++++++++*#@%+:.-%:.      ..%--...
                    ...:-=+=:--=:-:-++=+--=:-*@@@@%%%%%@@@@@%=......#=..       .=@-:...
                      .......-=====--:......::%=::=@=.:%+::#%:......%=..        =-%:-..
                            .........=#%@@%%##@@%##@#.:%@%##%@%#####%%..        ::@-=:..
                               ....=@#+++==+++#@#***%@%*+++*%#*++++++#@*....:=++*%===:..
                               ...*%++===--===++#@***@%*%@@#+=========+%@#+%#-..:=+=-..
                               ..=@*+==--:---==++#@*%@@#*%#+==---:--==++#%:+++==--:...
                                .#%+++==---===+++*%**@#**%+++==----===++*@:=:.......
                               ..*@*++++===++++++**+*%**++*++++====+++**#%:=:.
                               ...%%+++*++++**++++++*@%+*++++*++++**+**#@-=-..
                                ..:+@%*++****+*++**#@*#@**+++++*+++*+*%@-==:..
                                 ..::-*%@%%####%%@#=-+=-+%%#*****##%%*-=+=:..
                                  ...:-=-:::::::-=++=-::-=-::---:::-+++=-...
                                    .....:---==---:........:--====--::.....
                                        ...........      .............
`;

export default wetWilly;
